import Grid from "@mui/material/Grid";

import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsHead({
  fDocNo_Input,
  fDocNo,
  fLocation_MultiSelect,
  sLocationData,

  fParty_MultiSelect,
  sPartyData,
  // fCluster_MultiSelect,
  // sClusterData,

  //multiselect
  sWebPendingDoDetailReportData,
  sWebBetweenReportArr,
  // sLoadingBayData,
  // fLoadingBay_MultiSelect,

  // sTransactionData,
  // fTransaction_MultiSelect,

  sTruckData,
  fTruck_MultiSelect,
  fTruck,

  sDriverData,
  fDriver_MultiSelect,
  fDriver,

  fStatus,
  sStatusData,

  sDocTypeData,
  fDocType_MultiSelect,

  HeadObject,
  fLocation,
  fParty,
  // fCluster,
  // fLoadingBay,
  // fTransaction,
  fDocType,

  fFromDate,
  fToDate,
  fDate,
  fSalesGroup_MultiSelect,
  sSalesGroupData
}) {
  return (
    <form id="PendingDoDetailReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center "
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"DO-Stamping"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Transaction"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"22"}
                xLabelText="sDocType"
                xValue={HeadObject.sDocType}
                xOnChange={fDocType}
                xName={"sDocType"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sDocTypeData}
                xDisabled={
                  HeadObject?.sDocType?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sDocTypeArr}
                setValue={fDocType_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Doc Date"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDate"
                xValue={HeadObject.sDate}
                xOnChange={fDate}
                xName={"sDate"}
                xData={sWebBetweenReportArr}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={3} md={4} lg={4}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Doc.No"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sDocNo"
                xValue={HeadObject.sDocNo}
                xOnChange={fDocNo}
                xName={"sDocNo"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <CmpInputField
                xtabIndex={"02"}
                xValue={HeadObject.sDocNo_Input}
                xType={"text"} // text/number/password
                xName={"sDocNo_Input"}
                xReadOnly={
                  HeadObject?.sDocNo?.toUpperCase() === "ALL" ? true : false
                }
                xOnChange={fDocNo_Input}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid> */}
        {/* <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Cluster"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sCluster"
                xValue={HeadObject.sCluster}
                xOnChange={fCluster}
                xName={"sCluster"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sClusterData}
                xDisabled={
                  HeadObject?.sCluster?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sClusterArr}
                setValue={fCluster_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Party"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sParty"
                xValue={HeadObject.sParty}
                xOnChange={fParty}
                xName={"sParty"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sPartyData}
                xDisabled={
                  HeadObject?.sParty?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sPartyArr}
                setValue={fParty_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Loading Bay"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"18"}
                xLabelText="sLoadingBay"
                xValue={HeadObject.sLoadingBay}
                xOnChange={fLoadingBay}
                xName={"sLoadingBay"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sLoadingBayData}
                xDisabled={
                  HeadObject?.sLoadingBay?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                xValue={HeadObject.sLoadingBayArr}
                setValue={fLoadingBay_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid> */}

        {/* <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Transaction"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sTransaction"
                xValue={HeadObject.sTransaction}
                xOnChange={fTransaction}
                xName={"sTransaction"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sTransactionData}
                xDisabled={
                  HeadObject?.sTransaction?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                xValue={HeadObject.sTransactionArr}
                setValue={fTransaction_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            {/* <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Truck"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sTruck"
                xValue={HeadObject.sTruck}
                xOnChange={fTruck}
                xName={"sTruck"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sTruckData}
                xDisabled={
                  HeadObject?.sTruck?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sTruckArr}
                setValue={fTruck_MultiSelect}
              />
            </Grid> */}
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Driver"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sDriver"
                xValue={HeadObject.sDriver}
                xOnChange={fDriver}
                xName={"sDriver"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sTruckData}
                xDisabled={
                  HeadObject?.sDriver?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sDriverArr}
                setValue={fDriver_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            {/* <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Truck"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sTruck"
                xValue={HeadObject.sTruck}
                xOnChange={fTruck}
                xName={"sTruck"}
                xData={sWebPendingDoDetailReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"19"}
                options={sTruckData}
                xDisabled={
                  HeadObject?.sTruck?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sTruckArr}
                setValue={fTruck_MultiSelect}
              />
            </Grid> */}
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Status"} />
            </Grid>
            <Grid item xs={9} sm={9} md={4} lg={4}>
              <CmpSelectField
                xtabIndex={"20"}
                xLabelText="sStatus"
                xValue={HeadObject.sStatus}
                xOnChange={fStatus}
                xName={"sStatus"}
                xData={sStatusData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sales Group"} />
            </Grid>
            
            <Grid item  xs={9} sm={9} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"20"}
                options={sSalesGroupData}
                xDisabled={false}
                xValue={HeadObject.sSalesGroupArr}
                setValue={fSalesGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </form>
  );
}
